export default "__VITE_ASSET__BFcDYknN__"